<template>
  <footer>
    <!-- Contact -->
    <section id="contact">
      <v-container
        fluid
        class="black white--text">
        <v-row>
          <v-col
            cols="auto"
            :offset="$vuetify.breakpoint.lgAndUp ? 3 : 1">
            <h1 :class="`${$vuetify.breakpoint.lgAndUp ?' display-2': 'display-1'} font-weight-black my-5`">
              Talk To Us
            </h1>
            <v-btn
              to="contact-us"
              text
              dark
              small
              class="subtitle-1 font-weight-bold text-capitalize my-3 px-1">
              Enquire Now
            </v-btn>
            <p>
              100D Pasir Panjang Road<br>
              #02-09 Meissa<br>
              Singapore 118520
            </p>
            <v-row>
              <v-btn
                href="https://www.linkedin.com/company/pxs"
                text
                dark
                small>
                <v-icon>
                  mdi-linkedin
                </v-icon>
              </v-btn>
              <v-btn
                href="https://www.facebook.com/pixelsquad"
                text
                dark
                small>
                <v-icon>
                  mdi-facebook
                </v-icon>
              </v-btn>
              <v-btn
                href="http://instagram.com/pxs.sg"
                text
                dark
                small>
                <v-icon>
                  mdi-instagram
                </v-icon>
              </v-btn>
            </v-row>
            <p>
              <v-btn
                href="tel:+6563233531"
                text
                small
                dark
                class="ma-0 pa-0">
                +65 63233 531
              </v-btn>
            </p><p>
              <v-btn
                href="mailto:sales@pixelsquad.com.sg"
                text
                dark
                small
                class="ma-0 pa-0">
                sales@pixelsquad.com.sg
              </v-btn>
            </p>
          </v-col>
        </v-row>
      </v-container>
    </section>
    <!-- End Contact -->
  </footer>
</template>

<script>
export default {
	name: "Footer"
};
</script>